(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ 1425:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(2604);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ About; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/pure-react-carousel@1.29.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/pure-react-carousel/dist/react-carousel.es.css
var react_carousel_es = __webpack_require__(66962);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/pure-react-carousel@1.29.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/pure-react-carousel/dist/index.es.js
var index_es = __webpack_require__(73426);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/identity.js
var identity = __webpack_require__(85579);
var identity_default = /*#__PURE__*/__webpack_require__.n(identity);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/last.js
var last = __webpack_require__(87923);
var last_default = /*#__PURE__*/__webpack_require__.n(last);
;// CONCATENATED MODULE: ./lib/utils/getVimeoId.ts


function getVimeoId(url) {
    var urlAfterSplit = url.split(/(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/);
    return last_default()(urlAfterSplit.filter((identity_default())));
};

// EXTERNAL MODULE: ./src/utils/stringOrFirst.ts
var stringOrFirst = __webpack_require__(39327);
// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./src/components/home/pages/graphql/fragments/AboutPageConfigFields.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment AboutPageConfigFields on AboutPageConfig {\n    _id\n    config {\n      headingText\n      headingTextFontColor\n      subtitleText\n      subtitleTextFontColor\n      bannerBackgroundSrc\n      bannerBackgroundDescription\n      bannerContentType\n      bannerContentText\n      bannerContentSize\n      bannerContentDescription\n\n      boxesSectionBackgroundColor\n      leftButtonText\n      leftButtonBackgroundColor\n      leftButtonTextColor\n      leftButtonHoverColor\n      leftButtonBorderColor\n      leftButtonHref\n\n      rightButtonText\n      rightButtonBackgroundColor\n      rightButtonHoverColor\n      rightButtonBorderColor\n      rightButtonTextColor\n      rightButtonHref\n\n      leftBox {\n        ... on TextSideContent {\n          iconDescription\n          iconSrc\n          title\n          titleFontColor\n          text\n          textFontColor\n          textHref\n          textHrefHoverColor\n          width\n          height\n        }\n        ... on CarouselSideContent {\n          images {\n            src\n            alt\n          }\n          text\n          textHref\n          textHrefHoverColor\n          buttonText\n          buttonFontColor\n          buttonBackgroundColor\n          buttonHref\n        }\n      }\n      rightBox {\n        ... on TextSideContent {\n          iconDescription\n          iconSrc\n          title\n          titleFontColor\n          text\n          textFontColor\n          textHref\n          textHrefHoverColor\n          width\n          height\n        }\n        ... on CarouselSideContent {\n          images {\n            src\n            alt\n          }\n          text\n          textHref\n          textHrefHoverColor\n          buttonText\n          buttonFontColor\n          buttonBackgroundColor\n          buttonHref\n        }\n      }\n\n      videoSectionTitle\n      videoSectionBackground\n      videoSectionFontColor\n      videoSectionContentType\n      videoSectionContentText\n\n      joinSectionBackground\n      joinSectionTitle\n      joinSectionTitleFontColor\n      joinSectionSubtitle\n      joinSectionSubtitleFontColor\n      joinSectionButtonText\n      joinSectionButtonHref\n      joinSectionButtonColor\n      joinSectionButtonFontColor\n\n      logoSectionBackgroundColor\n      logoUrls {\n        imageUrl\n        url\n        description\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var AboutPageConfigFields = ((0,lib/* gql */.Ps)(_templateObject()));

;// CONCATENATED MODULE: ./src/components/home/pages/graphql/GetActiveAboutPageConfig.ts

function GetActiveAboutPageConfig_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetActiveAboutPageConfig($configId: ObjectId) {\n    getActiveAboutPageConfig(configId: $configId) {\n      ...AboutPageConfigFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    GetActiveAboutPageConfig_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var GetActiveAboutPageConfig = ((0,lib/* gql */.Ps)(GetActiveAboutPageConfig_templateObject(), AboutPageConfigFields));

// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
;// CONCATENATED MODULE: ./src/components/home/pages/AboutPage.tsx












// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore



function AboutPage() {
    var router = (0,next_router.useRouter)();
    var configId = (0,stringOrFirst/* default */.Z)(router.query.previewId);
    var ref = (0,useQuery/* useQuery */.a)(GetActiveAboutPageConfig, {
        variables: {
            configId: configId || null
        },
        fetchPolicy: "network-only"
    }), data = ref.data, loading = ref.loading;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarLayout/* default */.Z, {
        pb: 0,
        navbarProps: {
            mb: 0
        },
        showBanners: false,
        children: loading || !data ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
            justify: "center",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InnerAboutPage, (0,_object_spread/* default */.Z)({}, data === null || data === void 0 ? void 0 : data.getActiveAboutPageConfig.config))
    });
};
function InnerAboutPage(param) {
    var bannerBackgroundSrc = param.bannerBackgroundSrc, bannerBackgroundDescription = param.bannerBackgroundDescription, bannerContentType = param.bannerContentType, bannerContentText = param.bannerContentText, bannerContentSize = param.bannerContentSize, bannerContentDescription = param.bannerContentDescription, headingText = param.headingText, headingTextFontColor = param.headingTextFontColor, subtitleText = param.subtitleText, subtitleTextFontColor = param.subtitleTextFontColor, leftButtonHref = param.leftButtonHref, leftButtonText = param.leftButtonText, leftButtonBackgroundColor = param.leftButtonBackgroundColor, leftButtonHoverColor = param.leftButtonHoverColor, leftButtonBorderColor = param.leftButtonBorderColor, leftButtonTextColor = param.leftButtonTextColor, rightButtonHref = param.rightButtonHref, rightButtonBackgroundColor = param.rightButtonBackgroundColor, rightButtonHoverColor = param.rightButtonHoverColor, rightButtonBorderColor = param.rightButtonBorderColor, rightButtonTextColor = param.rightButtonTextColor, rightButtonText = param.rightButtonText, boxesSectionBackgroundColor = param.boxesSectionBackgroundColor, leftBox = param.leftBox, rightBox = param.rightBox, videoSectionContentType = param.videoSectionContentType, videoSectionContentText = param.videoSectionContentText, videoSectionBackground = param.videoSectionBackground, videoSectionFontColor = param.videoSectionFontColor, videoSectionTitle = param.videoSectionTitle, joinSectionBackground = param.joinSectionBackground, joinSectionTitle = param.joinSectionTitle, joinSectionTitleFontColor = param.joinSectionTitleFontColor, joinSectionSubtitle = param.joinSectionSubtitle, joinSectionSubtitleFontColor = param.joinSectionSubtitleFontColor, joinSectionButtonText = param.joinSectionButtonText, joinSectionButtonHref = param.joinSectionButtonHref, joinSectionButtonFontColor = param.joinSectionButtonFontColor, joinSectionButtonColor = param.joinSectionButtonColor, logoSectionBackgroundColor = param.logoSectionBackgroundColor, logoUrls = param.logoUrls;
    var intl = (0,useIntl/* default */.Z)();
    var locale = {
        id: intl.locale || intl.defaultLocale
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                position: "relative",
                pt: [
                    8,
                    8,
                    "100px"
                ],
                pb: [
                    "30px",
                    "30px",
                    "30px",
                    "80px"
                ],
                children: [
                    bannerBackgroundSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                        ignoreFallback: true,
                        alt: bannerBackgroundDescription || "",
                        src: bannerBackgroundSrc,
                        // height={["420px", "420px", "520px"]}
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        position: "absolute",
                        left: 0,
                        top: 0
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageGridContainer */.pf, {
                        paddingLeft: "0.5rem",
                        paddingRight: "0.5rem",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                            backgroundColor: "red",
                            position: "relative",
                            textAlign: [
                                "center",
                                "center",
                                "center",
                                "left"
                            ],
                            minHeight: "350px",
                            display: "flex",
                            flexDirection: [
                                "column",
                                "column",
                                "column",
                                "row"
                            ],
                            alignItems: [
                                "center",
                                "center",
                                "center",
                                "flex-start"
                            ],
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                    position: "relative",
                                    zIndex: 99,
                                    maxWidth: [
                                        "100%",
                                        "100%",
                                        "100%",
                                        "50%"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Heading */.E2, {
                                            as: "h1",
                                            fontSize: [
                                                "32px",
                                                "32px",
                                                "55px"
                                            ],
                                            color: headingTextFontColor,
                                            maxWidth: [
                                                "auto",
                                                "auto",
                                                "auto",
                                                "770px"
                                            ],
                                            lineHeight: [
                                                "38px",
                                                "38px",
                                                "60px"
                                            ],
                                            children: [
                                                locale.id === "en-US" ? headingText : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "The free wiki for local government innovation",
                                                    id: "5yQsxL"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("sup", {
                                                    css: {
                                                        margin: 0,
                                                        padding: 0,
                                                        fontSize: 32,
                                                        "@media (max-width: 768px)": {
                                                            top: "-0.25em"
                                                        }
                                                    },
                                                    children: "\xae"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                                            mt: [
                                                4,
                                                4,
                                                4,
                                                2
                                            ],
                                            as: "h2",
                                            fontWeight: [
                                                "bold",
                                                "bold",
                                                "normal"
                                            ],
                                            fontSize: [
                                                "18px",
                                                "18px",
                                                "28px"
                                            ],
                                            color: subtitleTextFontColor,
                                            maxWidth: [
                                                "auto",
                                                "auto",
                                                "auto",
                                                "610px"
                                            ],
                                            children: locale.id === "en-US" ? subtitleText : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Find the tools, inspiration and resources you need to build a smarter government.",
                                                id: "rdCWnJ"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                                            display: [
                                                "none",
                                                "none",
                                                "flex"
                                            ],
                                            wrap: "wrap",
                                            direction: [
                                                "column",
                                                "column",
                                                "column",
                                                "row"
                                            ],
                                            align: [
                                                "center",
                                                "center",
                                                "center",
                                                "unset"
                                            ],
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                                mt: [
                                                    "40px",
                                                    "40px",
                                                    "40px",
                                                    "40px"
                                                ],
                                                order: [
                                                    2,
                                                    2,
                                                    2,
                                                    1
                                                ],
                                                children: [
                                                    !leftButtonHref.startsWith("http") ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                        href: leftButtonHref,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                                                            variant: "primary",
                                                            bg: leftButtonBackgroundColor,
                                                            color: leftButtonTextColor,
                                                            borderColor: leftButtonBorderColor,
                                                            _hover: {
                                                                bg: leftButtonHoverColor,
                                                                borderColor: leftButtonHoverColor
                                                            },
                                                            mr: 6,
                                                            rel: "noreferrer noopener",
                                                            minWidth: "250px",
                                                            whiteSpace: "pre-wrap",
                                                            textAlign: "center",
                                                            children: locale.id === "en-US" ? leftButtonText : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Sign Up",
                                                                id: "39AHJm"
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                                                        variant: "primary",
                                                        bg: leftButtonBackgroundColor,
                                                        color: leftButtonTextColor,
                                                        borderColor: leftButtonBorderColor,
                                                        _hover: {
                                                            bg: leftButtonHoverColor,
                                                            borderColor: leftButtonHoverColor
                                                        },
                                                        external: "outside-redirect",
                                                        mr: 6,
                                                        rel: "noreferrer noopener",
                                                        minWidth: "250px",
                                                        whiteSpace: "pre-wrap",
                                                        textAlign: "center",
                                                        children: leftButtonText
                                                    }),
                                                    rightButtonHref.startsWith("http") ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                                                        variant: "primary",
                                                        external: "outside-redirect",
                                                        href: rightButtonHref,
                                                        bg: rightButtonBackgroundColor,
                                                        color: rightButtonTextColor,
                                                        borderColor: rightButtonBorderColor,
                                                        _hover: {
                                                            bg: rightButtonHoverColor,
                                                            borderColor: rightButtonHoverColor
                                                        },
                                                        minWidth: "250px",
                                                        whiteSpace: "pre-wrap",
                                                        textAlign: "center",
                                                        children: rightButtonText
                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                        href: rightButtonHref,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                                                            variant: "primary",
                                                            href: rightButtonHref,
                                                            bg: rightButtonBackgroundColor,
                                                            color: rightButtonTextColor,
                                                            borderColor: rightButtonBorderColor,
                                                            _hover: {
                                                                bg: rightButtonHoverColor,
                                                                borderColor: rightButtonHoverColor
                                                            },
                                                            minWidth: "250px",
                                                            whiteSpace: "pre-wrap",
                                                            textAlign: "center",
                                                            children: locale.id === "en-US" ? rightButtonText : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "\uD83C\uDF99 Govlaunch Podcast",
                                                                id: "hZP7Ph"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                bannerContentType === types/* IAboutContentType.Video */.H0.Video && bannerContentText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    zIndex: 1,
                                    mt: [
                                        8,
                                        8,
                                        8,
                                        0
                                    ],
                                    ml: [
                                        0,
                                        0,
                                        0,
                                        "auto"
                                    ],
                                    mx: [
                                        "auto",
                                        "auto",
                                        "auto",
                                        null
                                    ],
                                    width: [
                                        "100%",
                                        "100%",
                                        "100%",
                                        "50%"
                                    ],
                                    height: [
                                        200,
                                        300,
                                        bannerContentSize === "small" ? "250px" : "368px",
                                        bannerContentSize === "small" ? "250px" : "368px", 
                                    ],
                                    position: [
                                        "relative",
                                        "relative",
                                        "relative"
                                    ],
                                    right: 0,
                                    top: 0,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                                        title: "vimeo",
                                        id: "vimeoplayer",
                                        width: "100%",
                                        height: "100%",
                                        src: "https://player.vimeo.com/video/".concat(getVimeoId(bannerContentText), "?autoplay=0&loop=0&autopause=0&fullscreen=0"),
                                        allow: "fullscreen",
                                        frameBorder: "0"
                                    })
                                }),
                                bannerContentType === types/* IAboutContentType.Podcast */.H0.Podcast && bannerContentText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    zIndex: 1,
                                    mt: [
                                        8,
                                        8,
                                        8,
                                        0
                                    ],
                                    ml: [
                                        0,
                                        0,
                                        0,
                                        "auto"
                                    ],
                                    mx: [
                                        "auto",
                                        "auto",
                                        "auto",
                                        null
                                    ],
                                    width: [
                                        "100%",
                                        "100%",
                                        "100%",
                                        "50%"
                                    ],
                                    // height={[200, 300, "368px", "368px"]}
                                    position: [
                                        "relative",
                                        "relative",
                                        "relative"
                                    ],
                                    dangerouslySetInnerHTML: {
                                        __html: bannerContentText
                                    }
                                }),
                                bannerContentType === types/* IAboutContentType.Image */.H0.Image && bannerContentText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                                    ignoreFallback: true,
                                    zIndex: 1,
                                    mt: [
                                        8,
                                        8,
                                        8,
                                        0
                                    ],
                                    ml: [
                                        0,
                                        0,
                                        0,
                                        "auto"
                                    ],
                                    mx: [
                                        "auto",
                                        "auto",
                                        "auto",
                                        null
                                    ],
                                    width: [
                                        "100%",
                                        "100%",
                                        "550px",
                                        "550px"
                                    ],
                                    height: [
                                        200,
                                        300,
                                        "368px",
                                        "368px"
                                    ],
                                    src: bannerContentText,
                                    alt: bannerContentDescription || "",
                                    position: [
                                        "relative",
                                        "relative",
                                        "relative"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                display: [
                    "flex",
                    "flex",
                    "none"
                ],
                flexDirection: [
                    "column",
                    "column",
                    "row"
                ],
                mt: 5,
                px: 4,
                pb: 6,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: leftButtonHref,
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                            variant: "primary",
                            bg: leftButtonBackgroundColor,
                            color: leftButtonTextColor,
                            borderColor: leftButtonBorderColor,
                            _hover: {
                                bg: leftButtonHoverColor,
                                borderColor: leftButtonHoverColor
                            },
                            mr: 6,
                            rel: "noreferrer noopener",
                            href: leftButtonHref,
                            fullWidth: true,
                            whiteSpace: "pre-wrap",
                            textAlign: "center",
                            mb: [
                                4,
                                4,
                                0
                            ],
                            children: locale.id === "en-US" ? leftButtonText : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Sign Up",
                                id: "39AHJm"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                        href: rightButtonHref,
                        external: "outside-redirect",
                        variant: "primary",
                        bg: rightButtonBackgroundColor,
                        color: rightButtonTextColor,
                        borderColor: rightButtonBorderColor,
                        _hover: {
                            bg: leftButtonHoverColor,
                            borderColor: leftButtonHoverColor
                        },
                        fullWidth: true,
                        whiteSpace: "pre-wrap",
                        textAlign: "center",
                        children: locale.id === "en-US" ? rightButtonText : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "\uD83C\uDF99 Govlaunch Podcast",
                            id: "hZP7Ph"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                bg: boxesSectionBackgroundColor,
                pb: [
                    8,
                    8,
                    "80px"
                ],
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
                            columns: [
                                1,
                                1,
                                2
                            ],
                            spacing: 4,
                            mt: "60px",
                            children: [
                                leftBox.__typename === "TextSideContent" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoBox, {
                                    title: locale.id === "en-US" ? leftBox.title : intl.formatMessage({
                                        defaultMessage: "Search innovation projects",
                                        id: "odMQ4l"
                                    }),
                                    titleColor: leftBox.titleFontColor,
                                    text: locale.id === "en-US" ? leftBox.text : intl.formatMessage({
                                        defaultMessage: "Learn how your peers are experimenting with new technology, modern designs and better processes.",
                                        id: "wnpufW"
                                    }),
                                    textHref: leftBox.textHref,
                                    textHrefHoverColor: leftBox.textHrefHoverColor,
                                    textColor: leftBox.textFontColor,
                                    iconSrc: leftBox.iconSrc || "",
                                    width: leftBox.width,
                                    height: leftBox.height,
                                    alt: leftBox.iconDescription || ""
                                }),
                                leftBox.__typename === "CarouselSideContent" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoCarousel, {
                                    content: leftBox,
                                    shouldShowButton: !(leftBox.__typename === "CarouselSideContent" && rightBox.__typename === "CarouselSideContent")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    display: [
                                        "block",
                                        "block",
                                        "none"
                                    ],
                                    height: "1px",
                                    bg: "gray.100",
                                    my: 4
                                }),
                                rightBox.__typename === "TextSideContent" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoBox, {
                                    title: locale.id === "en-US" ? rightBox.title : intl.formatMessage({
                                        defaultMessage: "Discover disruptive technologies",
                                        id: "YfA6nW"
                                    }),
                                    titleColor: rightBox.titleFontColor,
                                    text: locale.id === "en-US" ? rightBox.text : intl.formatMessage({
                                        defaultMessage: "Research tools that can help you improve services and reduce costs.",
                                        id: "5nndhW"
                                    }),
                                    textHref: rightBox.textHref,
                                    textHrefHoverColor: rightBox.textHrefHoverColor,
                                    textColor: rightBox.textFontColor,
                                    iconSrc: rightBox.iconSrc || "",
                                    width: rightBox.width,
                                    height: rightBox.height,
                                    alt: rightBox.iconDescription || ""
                                }),
                                rightBox.__typename === "CarouselSideContent" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoCarousel, {
                                    content: rightBox,
                                    shouldShowButton: !(leftBox.__typename === "CarouselSideContent" && rightBox.__typename === "CarouselSideContent")
                                })
                            ]
                        }),
                        leftBox.__typename === "CarouselSideContent" && rightBox.__typename === "CarouselSideContent" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopSideButtons, {
                            leftBox: leftBox,
                            rightBox: rightBox
                        })
                    ]
                })
            }),
            (videoSectionTitle || videoSectionContentText) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                bg: videoSectionBackground,
                py: [
                    8,
                    8,
                    "80px"
                ],
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                    children: [
                        videoSectionTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                            as: "h3",
                            color: videoSectionFontColor,
                            fontWeight: "bold",
                            textAlign: "center",
                            fontSize: [
                                "2xl",
                                "2xl",
                                "32px"
                            ],
                            children: locale.id === "en-US" ? videoSectionTitle : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "...",
                                id: "Oo+0sJ"
                            })
                        }),
                        videoSectionContentText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                            display: "flex",
                            justifyContent: "center",
                            mt: videoSectionTitle ? 6 : 0,
                            children: [
                                videoSectionContentType === types/* IAboutContentType.Video */.H0.Video && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    width: "100%",
                                    height: [
                                        "200px",
                                        "200px",
                                        "400px"
                                    ],
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
                                        title: "vimeo",
                                        id: "vimeoplayer",
                                        width: "100%",
                                        height: "100%",
                                        src: "https://player.vimeo.com/video/".concat(getVimeoId(videoSectionContentText), "?autoplay=0&loop=0&autopause=0&fullscreen=0"),
                                        allow: "fullscreen",
                                        frameBorder: "0"
                                    })
                                }),
                                videoSectionContentType === types/* IAboutContentType.Podcast */.H0.Podcast && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    width: [
                                        350,
                                        350,
                                        720
                                    ],
                                    dangerouslySetInnerHTML: {
                                        __html: videoSectionContentText
                                    }
                                }),
                                videoSectionContentType === types/* IAboutContentType.Image */.H0.Image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                                    ignoreFallback: true,
                                    alt: "section image",
                                    src: videoSectionContentText,
                                    maxWidth: [
                                        "300px",
                                        "400px",
                                        "750px"
                                    ],
                                    objectFit: "cover"
                                })
                            ]
                        })
                    ]
                })
            }),
            (joinSectionTitle || joinSectionSubtitle || joinSectionButtonText) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                bg: joinSectionBackground,
                py: [
                    6,
                    6,
                    "80px",
                    "80px"
                ],
                textAlign: "center",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    maxWidth: "750px",
                    children: [
                        joinSectionTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                            as: "h3",
                            fontSize: [
                                "24px",
                                "24px",
                                "32px",
                                "32px"
                            ],
                            color: joinSectionTitleFontColor,
                            children: locale.id === "en-US" ? joinSectionTitle : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Government innovation doesn't need to be scary",
                                id: "7qeI0e"
                            })
                        }),
                        joinSectionSubtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                            mt: 4,
                            color: joinSectionSubtitleFontColor,
                            fontSize: "22px",
                            children: locale.id === "en-US" ? joinSectionSubtitle : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Join our community of local government innovators from the smallest towns to the largest counties – and everything in between.",
                                id: "ZU8jC+"
                            })
                        }),
                        joinSectionButtonText && joinSectionButtonHref.startsWith("http") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                            maxWidth: "450px",
                            variant: "solid",
                            href: joinSectionButtonHref,
                            external: "outside-redirect",
                            fullWidth: true,
                            mt: "30px",
                            bg: joinSectionButtonColor,
                            color: joinSectionButtonFontColor,
                            children: joinSectionButtonText
                        }),
                        joinSectionButtonText && !joinSectionButtonHref.startsWith("http") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: joinSectionButtonHref,
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                                maxWidth: "450px",
                                variant: "solid",
                                fullWidth: true,
                                mt: "30px",
                                bg: joinSectionButtonColor,
                                color: joinSectionButtonFontColor,
                                children: locale.id === "en-US" ? joinSectionButtonText : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Join Govlaunch",
                                    id: "ljH+sM"
                                })
                            })
                        })
                    ]
                })
            }),
            logoUrls.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                bg: logoSectionBackgroundColor,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* PageGridContainer */.pf, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        pb: 6,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Stack */.Kq, {
                            display: "flex",
                            direction: "row",
                            flexWrap: "wrap",
                            spacing: [
                                6,
                                6,
                                10
                            ],
                            justifyContent: "center",
                            children: logoUrls.map(function(logo, index) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                    href: (0,web/* getSecureRedirect */.Ej)(logo.url, "outside-govlaunch"),
                                    external: "govlaunch",
                                    _focus: undefined,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                                        ignoreFallback: true,
                                        src: logo.imageUrl,
                                        alt: logo.description || "",
                                        mt: 6,
                                        maxWidth: [
                                            "140px",
                                            "140px",
                                            "200px"
                                        ],
                                        maxHeight: [
                                            "42px",
                                            "42px",
                                            "60px"
                                        ]
                                    })
                                }, index);
                            })
                        })
                    })
                })
            })
        ]
    });
}
function InfoBox(param) {
    var title = param.title, titleColor = param.titleColor, text = param.text, textColor = param.textColor, textHref = param.textHref, textHrefHoverColor = param.textHrefHoverColor, iconSrc = param.iconSrc, width = param.width, height = param.height, alt = param.alt;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
            maxWidth: [
                "auto",
                "auto",
                "500px"
            ],
            mx: "auto",
            direction: "column",
            align: "center",
            justify: "center",
            textAlign: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    mb: [
                        0,
                        0,
                        0
                    ],
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                        ignoreFallback: true,
                        src: getResizedIconSrc({
                            iconSrc: iconSrc,
                            width: width,
                            height: height
                        }) || "",
                        alt: alt,
                        css: {
                            maxHeight: 350
                        }
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                    as: "h3",
                    fontSize: [
                        "2xl",
                        "2xl",
                        "28px"
                    ],
                    fontWeight: "bold",
                    mt: [
                        5,
                        5,
                        8
                    ],
                    color: titleColor,
                    children: title
                }),
                !textHref && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                    fontSize: [
                        "md",
                        "md",
                        "22px"
                    ],
                    color: textColor,
                    fontWeight: "normal",
                    mt: [
                        3,
                        3,
                        4
                    ],
                    children: text
                }),
                textHref && (textHref.startsWith("http") ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                    external: "outside-redirect",
                    href: textHref,
                    color: textColor,
                    whiteSpace: "pre-wrap",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                        fontSize: [
                            "md",
                            "md",
                            "22px"
                        ],
                        color: textColor,
                        fontWeight: "normal",
                        mt: [
                            3,
                            3,
                            4
                        ],
                        _hover: {
                            color: textHrefHoverColor || web/* palette.primary */.DG.primary
                        },
                        children: text
                    })
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: textHref,
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                        href: textHref,
                        color: textColor,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                            fontSize: [
                                "md",
                                "md",
                                "22px"
                            ],
                            color: textColor,
                            fontWeight: "normal",
                            mt: [
                                3,
                                3,
                                4
                            ],
                            _hover: {
                                color: textHrefHoverColor || web/* palette.primary */.DG.primary
                            },
                            children: text
                        })
                    })
                }))
            ]
        })
    });
}
function getResizedIconSrc(content) {
    if (!content.width && !content.height) {
        return content.iconSrc;
    }
    if (content.width && !content.height) {
        return "https://imaginary-ssl.govlaunch.com/resize?quality=100&compression=0&width=".concat(content.width, "&height=120&url=").concat(content.iconSrc);
    }
    if (!content.width && content.height) {
        return "https://imaginary-ssl.govlaunch.com/resize?quality=100&compression=0&height=".concat(content.height, "&url=").concat(content.iconSrc);
    }
    return "https://imaginary-ssl.govlaunch.com/resize?quality=100&compression=0&width=".concat(content.width, "&height=").concat(content.height, "&url=").concat(content.iconSrc);
}
function DesktopSideButtons(param) {
    var leftBox = param.leftBox, rightBox = param.rightBox;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
        display: [
            "none",
            "none",
            "block"
        ],
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* SimpleGrid */.MI, {
            columns: 2,
            spacing: 4,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                    display: "flex",
                    justifyContent: "center",
                    children: [
                        leftBox.__typename === "CarouselSideContent" && leftBox.buttonText && leftBox.buttonHref && leftBox.buttonHref.startsWith("http") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                            variant: "solid",
                            href: leftBox.buttonHref,
                            external: "outside-redirect",
                            mx: "auto",
                            mt: "24px",
                            bg: leftBox.buttonBackgroundColor,
                            color: leftBox.buttonFontColor || "#000",
                            children: leftBox.buttonText
                        }),
                        leftBox.__typename === "CarouselSideContent" && leftBox.buttonText && leftBox.buttonHref && !leftBox.buttonHref.startsWith("http") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: leftBox.buttonHref,
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                                variant: "solid",
                                mx: "auto",
                                mt: "24px",
                                bg: leftBox.buttonBackgroundColor,
                                color: leftBox.buttonFontColor || "#000",
                                children: leftBox.buttonText
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                    display: "flex",
                    justifyContent: "center",
                    children: [
                        rightBox.__typename === "CarouselSideContent" && rightBox.buttonText && rightBox.buttonHref && rightBox.buttonHref.startsWith("http") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                            variant: "solid",
                            href: rightBox.buttonHref,
                            external: "outside-redirect",
                            mx: "auto",
                            mt: "24px",
                            bg: rightBox.buttonBackgroundColor,
                            color: rightBox.buttonFontColor || "#000",
                            children: rightBox.buttonText
                        }),
                        rightBox.__typename === "CarouselSideContent" && rightBox.buttonText && rightBox.buttonHref && !rightBox.buttonHref.startsWith("http") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: rightBox.buttonHref,
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                                variant: "solid",
                                mx: "auto",
                                mt: "24px",
                                bg: rightBox.buttonBackgroundColor,
                                color: rightBox.buttonFontColor || "#000",
                                children: rightBox.buttonText
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function InfoCarousel(param) {
    var content = param.content, shouldShowButton = param.shouldShowButton;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_es/* CarouselProvider */.sj, {
                naturalSlideHeight: 0,
                naturalSlideWidth: 0,
                totalSlides: content.images.length,
                isIntrinsicHeight: true,
                isPlaying: true,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* Slider */.iR, {
                        children: content.images.map(function(image, index) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* Slide */.Mi, {
                                index: index,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        position: "relative"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* Image */.Gy, {
                                        src: image.src,
                                        alt: image.alt || "",
                                        hasMasterSpinner: true,
                                        css: {
                                            height: 350,
                                            maxWidth: 375,
                                            objectFit: "contain",
                                            margin: "0 auto"
                                        }
                                    })
                                })
                            }, image.src);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            width: "100%",
                            justifyContent: "center",
                            minHeight: "28px"
                        },
                        children: content.images.length > 1 && content.images.map(function(_, index) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* Dot */.oT, {
                                slide: index,
                                css: {
                                    marginTop: 12,
                                    marginRight: 8,
                                    borderRadius: "100%",
                                    width: 16,
                                    height: 16,
                                    border: 0,
                                    background: "#E3E6EB",
                                    "&:disabled": {
                                        background: "#96A3B5"
                                    }
                                }
                            }, index);
                        })
                    })
                ]
            }),
            content.text && !content.textHref && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                textAlign: "center",
                fontSize: "2xl",
                fontWeight: "bold",
                mt: 4,
                color: "gray.900",
                maxWidth: "375px",
                mx: "auto",
                children: content.text
            }),
            content.text && content.textHref && (content.textHref.startsWith("http") ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                    external: "outside-redirect",
                    href: content.textHref,
                    whiteSpace: "pre-wrap",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                        textAlign: "center",
                        fontSize: "2xl",
                        fontWeight: "bold",
                        mt: 4,
                        color: "gray.900",
                        maxWidth: "375px",
                        mx: "auto",
                        _hover: {
                            color: content.textHrefHoverColor || web/* palette.primary */.DG.primary
                        },
                        children: content.text
                    })
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: content.textHref,
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                        href: content.textHref,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                            textAlign: "center",
                            fontSize: "2xl",
                            fontWeight: "bold",
                            mt: 4,
                            color: "gray.900",
                            maxWidth: "375px",
                            mx: "auto",
                            _hover: {
                                color: content.textHrefHoverColor || web/* palette.primary */.DG.primary
                            },
                            children: content.text
                        })
                    })
                })
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                display: shouldShowButton ? "flex" : [
                    "flex",
                    "flex",
                    "none"
                ],
                justifyContent: "center",
                children: [
                    content.buttonText && content.buttonHref && content.buttonHref.startsWith("http") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                        variant: "solid",
                        href: content.buttonHref,
                        external: "outside-redirect",
                        mx: "auto",
                        mt: "24px",
                        bg: content.buttonBackgroundColor,
                        color: content.buttonFontColor || "#000",
                        children: content.buttonText
                    }),
                    content.buttonText && content.buttonHref && !content.buttonHref.startsWith("http") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: content.buttonHref,
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* AnchorButton */.AN, {
                            variant: "solid",
                            mx: "auto",
                            mt: "24px",
                            bg: content.buttonBackgroundColor,
                            color: content.buttonFontColor || "#000",
                            children: content.buttonText
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/about.tsx



function About() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AboutPage, {});
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3481,5522,2583,9932,9774,2888,179], function() { return __webpack_exec__(1425); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);